import * as React from 'react';
import { ChevronDown } from 'lucide-react';

import { cn } from '@shared/lib/utils';

export interface NativeSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  containerClassName?: string;
  iconClassName?: string;
}

const NativeSelect = React.forwardRef<HTMLSelectElement, NativeSelectProps>(
  ({ className, containerClassName, children, iconClassName, ...props }, ref) => {
    return (
      <div className={cn('relative', containerClassName)}>
        <select
          ref={ref}
          className={cn(
            'h-11 w-full appearance-none rounded-none border border-input bg-background px-4 py-0 pr-10 text-base leading-none ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
            className
          )}
          {...props}
        >
          {children}
        </select>
        <ChevronDown
          aria-hidden="true"
          className={cn(
            'pointer-events-none absolute right-4 top-1/2 h-4 w-4 -translate-y-1/2 opacity-50',
            iconClassName
          )}
        />
      </div>
    );
  }
);
NativeSelect.displayName = 'NativeSelect';

export { NativeSelect };
